<template>
  <div class="w100m" >

    <div class="w100 flexVC" v-if="$store.state.isPc">
      <div class="webview flexVC" style="padding-top: 180px;" >
        <div v-html="this.partyData.desc" style="padding-bottom: 80px;"></div>
      </div>

    </div>
    <div class="w100m  Bf0f2f5 flexVC" v-if="!$store.state.isPc">
      <div class="webview-m flexVC" style="padding-top: 1.80rem;" >
        <div v-html="this.partyData.desc" style="padding-bottom: 80px;"></div>
      </div>

    </div>
    <shape-footer></shape-footer>
  </div>
</template>

<script>
  import shapeFooter from '@/components/ShapeFooter'
  import {partyDetailData} from '@/utils/staticData'
  export default {
    name: "PartyDetail",
    data() {
      return {
        isShow: true,
        cover: 'cover',
        partyData: [],
        title: '趁早PARTY历年回顾',
      }
    },

    components: {
      shapeFooter,
    },

    mounted() {
      window.scrollTo(0,0);
      partyDetailData.forEach(item => {
        console.log(item)
        if (item.year == this.$route.query.data) {
          this.partyData = item
        }
      })
    }

  }
</script>

<style scoped>

  .webview{
    width: 1000px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    text-align: justify;
  }

  .webview img{
    margin:  0 30px;
  }

  .webview-m{
    width: 6.54rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
    text-align: justify;
  }
  .webview-m img{
    margin:  0 0.35rem;
  }

  /*p{*/
  /*  font-size: 16px;*/
  /*  font-family: PingFangSC-Regular, PingFang SC;*/
  /*  font-weight: 400;*/
  /*  color: rgba(0, 0, 0, 0.85);*/
  /*  line-height: 30px;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/page/activity/PartyDetail.vue